module.exports = __webpack_public_path__ + "static/media/piper_hello_es.be3fa6cd.svg";